import { submit_form } from './functions';
import initOverlayer from '../general/overlayer';
import initCookieBanner from '../general/cookieBanner';

export let ajaxBaseUrl = '';

export const startUp = () => {
  if (initVals.webRoot && initVals.webRoot != '') {
    ajaxBaseUrl = '/' + initVals.webRoot;
  }

  //scroll window to content container
  const scrollBtn = document.querySelector('.fixedArrowScroll');
  if (scrollBtn) {
    scrollBtn.addEventListener('click', () => {
      const container = document.querySelector('.container');
      if (container) {
        container.scrollIntoView({
          behavior: 'smooth',
        });
      }
    });
  }

  //header search form
  const search = document.getElementById('searchModal');

  if (search && search.dataset.search_url) {
    const searchBtn = document.getElementById('searchBtn');
    const searchInput = search.querySelector('input');

    searchBtn.addEventListener('click', e => {
      e.preventDefault();

      if (searchInput.value != '') {
        document.location = search.dataset.search_url + '/' + searchInput.value;
      }
    });

    searchInput.addEventListener('keyup', e => {
      e.preventDefault();

      if (e.keyCode == 13 && searchInput.value != '') {
        document.location = search.dataset.search_url + '/' + searchInput.value;
      }
    });
  }

  //GENERAL FORM SCRIPTS
  const form = document.querySelectorAll('form:not(.form-inline)');
  if (form) {
    form.forEach(form => {
      console.log(form);
      form.addEventListener('submit', e => {
        e.preventDefault();
        const recaptchaKey = form.dataset.recaptcha ?? null;
        if (recaptchaKey) {
          grecaptcha.ready(function () {
            grecaptcha.execute(recaptchaKey, { action: 'submit' }).then(function (token) {
              submit_form(form, token);
            });
          });
        } else {
          submit_form(form);
        }
      });
    });

    //remove browser default error input popups
    document.addEventListener(
      'invalid',
      (function () {
        return function (e) {
          e.preventDefault();

          e.target.classList.add('is-invalid');
          const closestLabel = e.target.closest('label');
          if (closestLabel) {
            closestLabel.classList.add('is-invalid');
          }
        };
      })(),
      true,
    );

    //honeypot - extra bot challange
    const h8pt = document.querySelectorAll("input[name='h8pt']");
    const formInputs = document.querySelectorAll('input');
    if (h8pt && h8pt.length > 0) {
      setTimeout(function () {
        formInputs.forEach(input => {
          input.addEventListener('click', e => {
            h8pt.forEach(inputHoneypot => {
              inputHoneypot.value = '';
              inputHoneypot.setAttribute('value', '');
            });
          });
        });
      }, 3000);
    }
  }

  //input - remove class error on focus
  const name = document.querySelectorAll('*[name]');
  name.forEach(item => {
    item.addEventListener('focus', e => handleNameFocusAndChange(e));
    item.addEventListener('change', e => handleNameFocusAndChange(e));
  });

  const handleNameFocusAndChange = e => {
    e.target.classList.remove('is-invalid');
    const groups = e.target.closest('label');
    if (e.target.type == 'radio') {
      document.querySelectorAll('input[name="' + e.target.name + '"]').forEach(input => {
        input.classList.remove('is-invalid');
      });
    }
    if (groups) {
      groups.classList.remove('is-invalid');
    }
  };

  //overlayer
  initOverlayer();

  //cookie banner
  if (document.getElementById('ccb-panel')) initCookieBanner();
};
